<template>
  <v-main v-if="!currentUser.is_student">
    <v-row v-if="test" class="test-info">
      <v-col cols="6" class="test-details">
        <h2>{{ test.tname }}</h2>
        <h4>{{ test.subject.name }}</h4>
        <h4>{{ test.subject.room.sections }}</h4>
        <p class="description-text">{{ startDateTime }} - {{ endDateTime }}</p>
      </v-col>
      <v-col cols="6" class="align-end">
         <p><v-btn :to="`/test/${$route.params.tid}/stats`">View Results</v-btn></p>
          <p><v-btn @click="createPDF" color="primary" class="pdf-btn">Download</v-btn></p>
      </v-col>
    </v-row>
    <v-card class="cheating_students mb-16">
      <v-card-title>
        Cheating Students
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table ref="cheatingTable" :headers="headers" :items="cheaters" :search="search" :items-per-page="-1">
        <template v-slot:item.created="{ item }">
          <span>{{ getCreated(item.created) }}</span>
          <!-- <span><i class="fas fa-times" v-if="!item.correct"></i></span> -->
        </template>
      </v-data-table>
    </v-card>
    <v-footer fixed class="font-weight-medium">
      <v-col class="text-center" cols="12">
        <strong>
          <Timer v-if="test" :endTimer="test.end_datetime" />
        </strong>
      </v-col>
    </v-footer>
  </v-main>
</template>

<script>
import Timer from "@components/widgets/misc/Timer";
import { mapActions, mapGetters } from "vuex";
import testsApi from "@api/tests/all_tests";
import Helper from "@utils/misc";
import moment from "moment";

import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  name: "TestCheating",
  components: {
    Timer
  },
  data() {
    return {
      test: null,
      cheaters: [],
      search: "",
      getCheatersInterval: null,
      headers: [
        {
          text: "Student",
          align: "start",
          sortable: false,
          value: "student.full_name"
        },
        { text: "Phone", value: "student.phone" },
        { text: "Time", value: "created" }
      ]
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    startDateTime: function() {
      var d = new Date(this.test.start_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    },
    endDateTime: function() {
      var d = new Date(this.test.end_datetime * 1000);
      return moment(d).format("D MMM h:mma");
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    getCreated(created) {
      return moment(new Date(created)).format("hh:mm A");
    },
    // gets the test details for displaying
    async getTestDetails() {
      this.setLoading(true);
      // gets test details
      let testFromServer = await testsApi.getTestDetails(
        this.accessToken,
        this.$route.params.tid
      );
      if (!Helper.handleErrors(testFromServer, this.handleErrors)) return;
      // display
      this.test = testFromServer;
      this.setLoading(false);
    },
    // gets stored cheating students from the server
    async getCheatingStudentsFromServer() {
      this.setLoading(true);
      let cheatersFromServer = await testsApi.getCheatersFromServer(
        this.accessToken,
        this.$route.params.tid
      );
      if (!Helper.handleErrors(cheatersFromServer, this.handleErrors)) return;
      this.cheaters = cheatersFromServer;
      this.setLoading(false);
    },

    // connects to sockets and mentions handlers for events
    async connectToSockets() {
      var self = this;

      this.getCheatersInterval = setInterval(function() {
          self.getCheatingStudentsFromServer();
      }, 15000);

      // io.on() = data => {
      //   console.log(data);
      //   let recData = JSON.parse(event.data);
      //   if (recData.event == "Inform") {
      //     self.cheaters.push({
      //       created: new Date(),
      //       student: {
      //         full_name: recData.user_full_name,
      //         phone: recData.phone
      //       }
      //     });
      //     console.log(self.cheaters);
      //   }
      //   return false;
      // };
    },

    handleErrors(err) {
      this.setLoading(false);
      console.log(err);
    },

    createPDF () {
      this.setLoading(true);
      var source =  this.$refs["cheatingTable"];
      let rows = [];
      let columnHeader = ['Student', 'Phone', 'Timestamp'];
      let pdfName = `Cheatings_${this.test.tname}`;
      source.items.forEach(element => {
          var temp = [
              element.student.full_name,
              element.student.phone,
              this.getCreated(element.created),
          ];
          rows.push(temp);
      });
      var doc = new jsPDF();

      // Cheats header
      let detailsHeader = ['Test Name','Subject','Test Date','Teacher'];
      var detailRow = [
        this.test.tname,
        `${this.test.subject.name}-${this.test.subject.room.sections}`,
        `${this.startDateTime}-${this.endDateTime}` ,
        this.test.created_by.full_name,
      ];
      doc.autoTable(detailsHeader,[detailRow,],{startY:10,styles: { fillColor: [255, 255, 255], textColor: [0,0,0]} },);

      doc.autoTable(columnHeader, rows, { startY: 30 });
      doc.save(pdfName + '.pdf');
      this.setLoading(false);
    }


  },
  beforeDestroy() {
    clearInterval(this.getCheatersInterval);
  },
  created() {
    if(this.currentUser.is_student) return;
    this.getTestDetails();
    this.getCheatingStudentsFromServer();
    this.connectToSockets();
  }
};
</script>

<style scoped>
.cheating_students {
  max-width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}
.test-info {
  padding-right: 5%;
  margin-left: 5%;
  margin-top: 15px;
}

.align-end {
  text-align: end;
}
.test-description {
  padding: 10px;
  padding-left: 30px;
  border-top: 5px solid #009688;
  border-radius: 20px;
}
.test-details{
    word-break: break-word;
}
</style>